export default {
  title: "Companies",
  locale: {
    english: "English",
    swedish: "Swedish",
  },
  home: {
    home: "Home",
    welcome: "Welcome to Companies",
  },
  time: {
    time: "Time",
    project: "Project",
    task: "Task",
    description: "Description",
    startTime: "Start time",
    endTime: "End time",
    total: "Total",
    today: "Today",
    start: "Start",
    stop: "Stop",
    edit: "Edit",
    delete: "Delete",
    add: "Add time",
    submit: "Save",
    noTimes: "No times for this date.",
    confirmDelete: "Are you sure you want to delete this time entry?",
    confirmStartDifferentDay:
      "Start time is not on the same day as the date. Are you sure you want to proceed?",
  },
  report: {
    report: "Report",
  },
  login: {
    login: "login",
    title: "Logga in",
    email: "Email",
    password: "Password",
    submit: "Login",
    error: "Login failed. Please try again",
  },
  logout: "Logout",
  confirmation: "Are you sure?",
  yes: "Yes",
  no: "No",
  ok: "OK",
  cancel: "Cancel",
  loading: "Loading...",
  error: {
    code: {
      title: "Server responded with error",
      message: "The following error occurred: {error}",
    },
  },
};
